module.exports = __webpack_public_path__ + "static/media/error.7d770d5f.svg";